import React from "react";
import "./Footer.css";

const Footer = () => {
	return (
		<footer role="contentinfo" aria-label="Footer" >
			<div>
				<p>&copy; 2025 Percara negocios inmobiliarios. Todos los derechos reservados.</p>
				<p>
					Esta página fue creada por <strong><a href="https://www.instagram.com/revolucionred/">Revolucion Red</a></strong> y
					el desarrollador <strong><a href="https://wa.me/+5493412275598"> Juanma Toniolo</a></strong>.
				</p>
				<nav aria-label="Navegación de pie de página">
					<ul>
						<li>
							<a
								href="#privacy-policy"
								title="Política de privacidad"
								aria-label="Política de privacidad"
							>
								Política de Privacidad
							</a>
						</li>
						<li>
							<a
								href="#terms-of-service"
								title="Términos de servicio"
								aria-label="Términos de servicio"
							>
								Términos de Servicio
							</a>
						</li>
					</ul>
				</nav>
				<div>
					<p>Síguenos en nuestras redes sociales:</p>
					<ul
						style={{
							display: "flex",
							justifyContent: "center",
							padding: 0,
						}}
					>
						<li style={{ margin: "0 10px" }}>
							<a
								href="https://www.instagram.com/revolucionred/"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Instagram de Revolución Red"
							>
								Instagram
							</a>
						</li>
				
						<li style={{ margin: "0 10px" }}>
							<a
								href="https://wa.me/+5493416024181"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Whatsapp de Revolución Red"
							>
								Whatsapp
							</a>
						</li>
						
						<li style={{ margin: "0 10px" }}>
							<a
								href="https://www.facebook.com/profile.php?id=61559431053017"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Facebook de Revolución Red"
							>
								Facebook
							</a>
						</li>
					</ul>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
